


































import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/shared/components/Modal.vue';
import { Getter, Mutation } from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { ADD_FLOW } from '@/store/bot-designer/paths/mutationTypes';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import { flowsApi } from '@/features/bots/services/flows';
import Toast from '../services/toast';
import appInsights from '../services/appInsights';
import { maxLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import VuelidateUtil from '@/shared/util/vuelidateUtil';

@Component({
	mixins: [
		validationMixin
	],
	components: {
		Modal
	},
	validations: {
		flowName: {
			required,
			maxLength: maxLength(50),
			flowNameValid: VuelidateUtil.objectName
		}
	}
})
export default class AddFlowModal extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Mutation(ADD_FLOW) public addFlowToList: (path: FlowListItemViewModel) => void;
	public flowName: string = '';
	public isLoading: boolean = false;

	public mounted() {
		const addFlowInput: any = this.$refs.addFlowInput;
		if (addFlowInput) {
			addFlowInput.focus();
		}
	}

	public async addFlow() {
		if (this.$v.$invalid) {
			return;
		}

		appInsights.trackEvent({ name: 'Add flow clicked' }, { workspaceId: this.currentWorkspace.id });
		this.isLoading = true;
		try {
			const flowItem = await flowsApi.addFlow(this.currentWorkspace.id,  { name: this.flowName });
			this.addFlowToList(flowItem);
			this.isLoading = false;
			this.$emit('flow-added', flowItem);
			this.close();
		} catch (e: any) {
			this.isLoading = false;
			if (e.status === 409) {
				Toast.showError(e.message);
				return;
			}
			Toast.showError('Failed to add flow');
		}
	}

	public getErrorMessage(): string {
		if (this.$v.flowName.required && !this.$v.flowName.flowNameValid) {
			return 'Name must only contain letters, numbers, spaces, and the characters , - _ ( ) &';
		}
		if (!this.$v.flowName.maxLength) {
			return 'Name must not be longer than 50 characters';
		}
		if (!this.$v.flowName.required) {
			return 'Name must not be empty';
		}

		return '';
	}

	public close() {
		this.$emit('close');
	}
}
